import { Helmet } from "react-helmet-async";
import React from "react";
import { urlPageForSchema } from "@Components/SchemaOrg/SchemaSiteNavigationElement";
import { env } from "build/env";
export var SchemaRestaurant = _ref => {
  var {
    store,
    storeHours
  } = _ref;
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Restaurant",
    image: ["".concat(store && store.store_preview_image_desktop ? store.store_preview_image_desktop : "")],
    "@id": "https://www.miscusi.com",
    name: "Miscusi",
    alternateName: "".concat(store && store.frontend_name ? store.frontend_name : ""),
    address: {
      "@type": "PostalAddress",
      streetAddress: "".concat(store && store.address && store.address.address1 ? store.address.address1 : ""),
      addressLocality: "".concat(store && store.address && store.address.city ? store.address.city : ""),
      addressRegion: "Italy",
      postalCode: "".concat(store && store.address && store.address.post_code ? store.address.post_code : "")
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: "".concat(store && store.latitude ? store.latitude : ""),
      longitude: "".concat(store && store.longitude ? store.longitude : "")
    },
    url: "".concat(window.location.href),
    telephone: "".concat(store && store.address && store.address.phone_number ? store.address.phone_number : ""),
    hasMap: "https://maps.google.com/?q=".concat(store && store.address && store.address.address1 ? "Miscusi , " + store.address.address1 + "," + store.address.city + "," + store.address.post_code : "Miscusi"),
    servesCuisine: "Italian",
    openingHours: storeHours ? storeHours : "",
    menu: "".concat(urlPageForSchema(env.URL_MISCUSI, "menu-ristorante")),
    acceptsReservations: "True",
    paymentAccepted: "Cash, Credit Card"
  })));
};